import { Leaf } from "lucide-react";

/** Thin top strip on every page: network affiliation credit. */
export default function NetworkStrip() {
  return (
    <a
      href="https://socialpulse.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="network-strip"
      className="flex items-center justify-center gap-3 bg-[color:var(--sepia)] text-[color:var(--parchment)]/95 hover:text-[color:var(--brass-light)] text-center py-2 px-4 font-sans-ui text-[11px] tracking-[0.2em] uppercase transition-colors"
    >
      <span className="hidden sm:flex items-center gap-2 text-[color:var(--brass)]">
        <span className="h-px w-10 bg-[color:var(--brass)]/60" />
        <Leaf size={12} />
      </span>
      Part of Social Pulse ® Network
      <span className="hidden sm:flex items-center gap-2 text-[color:var(--brass)]">
        <Leaf size={12} className="scale-x-[-1]" />
        <span className="h-px w-10 bg-[color:var(--brass)]/60" />
      </span>
    </a>
  );
}
